import { useEffect, useState } from "react";

interface OfferCountdownProps {
  targetDate: Date;
}

export const OfferCountdown = ({ targetDate }: OfferCountdownProps) => {
  const [timeLeft, setTimeLeft] = useState<string | JSX.Element[]>("");

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const diffTime = targetDate.getTime() - now.getTime();

      if (diffTime <= 0) {
        setTimeLeft("Expired");
        return;
      }

      const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));

      const parts: JSX.Element[] = [];

      if (days > 0) {
        parts.push(
          <span key="days">
            <span className="font-bold">{days}</span> day{days !== 1 ? "s" : ""}
          </span>,
        );
      }
      if (hours > 0) {
        parts.push(
          <span key="hours">
            <span className="font-bold">{hours}</span> hour
            {hours !== 1 ? "s" : ""}
          </span>,
        );
      }
      if (minutes > 0 || parts.length === 0) {
        parts.push(
          <span key="minutes">
            <span className="font-bold">{minutes}</span> minute
            {minutes !== 1 ? "s" : ""}
          </span>,
        );
      }

      setTimeLeft(parts);
    };

    calculateTimeLeft();
    const intervalId = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(intervalId);
  }, [targetDate]);

  return (
    <span className="text-xs text-status-success">
      {Array.isArray(timeLeft) ? (
        <>
          {timeLeft.map((part, i) => (
            <span key={part.key}>
              {part}
              {i < timeLeft.length - 1 && " "}
            </span>
          ))}
        </>
      ) : (
        timeLeft
      )}
    </span>
  );
};
